module.exports = __webpack_public_path__ + "img/8.45a1fec6.png";